import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import PostgrestBuilder from './PostgrestBuilder';
var PostgrestTransformBuilder = /*#__PURE__*/function (_PostgrestBuilder) {
  _inherits(PostgrestTransformBuilder, _PostgrestBuilder);
  function PostgrestTransformBuilder() {
    _classCallCheck(this, PostgrestTransformBuilder);
    return _possibleConstructorReturn(this, _getPrototypeOf(PostgrestTransformBuilder).apply(this, arguments));
  }
  _createClass(PostgrestTransformBuilder, [{
    key: "select",
    /**
     * Perform a SELECT on the query result.
     *
     * By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
     * return modified rows. By calling this method, modified rows are returned in
     * `data`.
     *
     * @param columns - The columns to retrieve, separated by commas
     */
    value: function select(columns) {
      // Remove whitespaces except when quoted
      var quoted = false;
      var cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map(function (c) {
        if (/\s/.test(c) && !quoted) {
          return '';
        }
        if (c === '"') {
          quoted = !quoted;
        }
        return c;
      }).join('');
      this.url.searchParams.set('select', cleanedColumns);
      if (this.headers['Prefer']) {
        this.headers['Prefer'] += ',';
      }
      this.headers['Prefer'] += 'return=representation';
      return this;
    }
    /**
     * Order the query result by `column`.
     *
     * You can call this method multiple times to order by multiple columns.
     *
     * You can order foreign tables, but it doesn't affect the ordering of the
     * current table.
     *
     * @param column - The column to order by
     * @param options - Named parameters
     * @param options.ascending - If `true`, the result will be in ascending order
     * @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
     * `null`s appear last.
     * @param options.foreignTable - Set this to order a foreign table by foreign
     * columns
     */
  }, {
    key: "order",
    value: function order(column) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$ascending = _ref.ascending,
        ascending = _ref$ascending === void 0 ? true : _ref$ascending,
        nullsFirst = _ref.nullsFirst,
        foreignTable = _ref.foreignTable;
      var key = foreignTable ? "".concat(foreignTable, ".order") : 'order';
      var existingOrder = this.url.searchParams.get(key);
      this.url.searchParams.set(key, "".concat(existingOrder ? "".concat(existingOrder, ",") : '').concat(column, ".").concat(ascending ? 'asc' : 'desc').concat(nullsFirst === undefined ? '' : nullsFirst ? '.nullsfirst' : '.nullslast'));
      return this;
    }
    /**
     * Limit the query result by `count`.
     *
     * @param count - The maximum number of rows to return
     * @param options - Named parameters
     * @param options.foreignTable - Set this to limit rows of foreign tables
     * instead of the current table
     */
  }, {
    key: "limit",
    value: function limit(count) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        foreignTable = _ref2.foreignTable;
      var key = typeof foreignTable === 'undefined' ? 'limit' : "".concat(foreignTable, ".limit");
      this.url.searchParams.set(key, "".concat(count));
      return this;
    }
    /**
     * Limit the query result by `from` and `to` inclusively.
     *
     * @param from - The starting index from which to limit the result
     * @param to - The last index to which to limit the result
     * @param options - Named parameters
     * @param options.foreignTable - Set this to limit rows of foreign tables
     * instead of the current table
     */
  }, {
    key: "range",
    value: function range(from, to) {
      var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        foreignTable = _ref3.foreignTable;
      var keyOffset = typeof foreignTable === 'undefined' ? 'offset' : "".concat(foreignTable, ".offset");
      var keyLimit = typeof foreignTable === 'undefined' ? 'limit' : "".concat(foreignTable, ".limit");
      this.url.searchParams.set(keyOffset, "".concat(from));
      // Range is inclusive, so add 1
      this.url.searchParams.set(keyLimit, "".concat(to - from + 1));
      return this;
    }
    /**
     * Set the AbortSignal for the fetch request.
     *
     * @param signal - The AbortSignal to use for the fetch request
     */
  }, {
    key: "abortSignal",
    value: function abortSignal(signal) {
      this.signal = signal;
      return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be one row (e.g. using `.limit(1)`), otherwise this
     * returns an error.
     */
  }, {
    key: "single",
    value: function single() {
      this.headers['Accept'] = 'application/vnd.pgrst.object+json';
      return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
     * this returns an error.
     */
  }, {
    key: "maybeSingle",
    value: function maybeSingle() {
      this.headers['Accept'] = 'application/vnd.pgrst.object+json';
      this.allowEmpty = true;
      return this;
    }
    /**
     * Return `data` as a string in CSV format.
     */
  }, {
    key: "csv",
    value: function csv() {
      this.headers['Accept'] = 'text/csv';
      return this;
    }
    /**
     * Return `data` as an object in [GeoJSON](https://geojson.org) format.
     */
  }, {
    key: "geojson",
    value: function geojson() {
      this.headers['Accept'] = 'application/geo+json';
      return this;
    }
    /**
     * Return `data` as the EXPLAIN plan for the query.
     *
     * @param options - Named parameters
     *
     * @param options.analyze - If `true`, the query will be executed and the
     * actual run time will be returned
     *
     * @param options.verbose - If `true`, the query identifier will be returned
     * and `data` will include the output columns of the query
     *
     * @param options.settings - If `true`, include information on configuration
     * parameters that affect query planning
     *
     * @param options.buffers - If `true`, include information on buffer usage
     *
     * @param options.wal - If `true`, include information on WAL record generation
     *
     * @param options.format - The format of the output, can be `"text"` (default)
     * or `"json"`
     */
  }, {
    key: "explain",
    value: function explain() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$analyze = _ref4.analyze,
        analyze = _ref4$analyze === void 0 ? false : _ref4$analyze,
        _ref4$verbose = _ref4.verbose,
        verbose = _ref4$verbose === void 0 ? false : _ref4$verbose,
        _ref4$settings = _ref4.settings,
        settings = _ref4$settings === void 0 ? false : _ref4$settings,
        _ref4$buffers = _ref4.buffers,
        buffers = _ref4$buffers === void 0 ? false : _ref4$buffers,
        _ref4$wal = _ref4.wal,
        wal = _ref4$wal === void 0 ? false : _ref4$wal,
        _ref4$format = _ref4.format,
        format = _ref4$format === void 0 ? 'text' : _ref4$format;
      var options = [analyze ? 'analyze' : null, verbose ? 'verbose' : null, settings ? 'settings' : null, buffers ? 'buffers' : null, wal ? 'wal' : null].filter(Boolean).join('|');
      // An Accept header can carry multiple media types but postgrest-js always sends one
      var forMediatype = this.headers['Accept'];
      this.headers['Accept'] = "application/vnd.pgrst.plan+".concat(format, "; for=\"").concat(forMediatype, "\"; options=").concat(options, ";");
      if (format === 'json') return this;else return this;
    }
    /**
     * Rollback the query.
     *
     * `data` will still be returned, but the query is not committed.
     */
  }, {
    key: "rollback",
    value: function rollback() {
      var _a;
      if (((_a = this.headers['Prefer']) !== null && _a !== void 0 ? _a : '').trim().length > 0) {
        this.headers['Prefer'] += ',tx=rollback';
      } else {
        this.headers['Prefer'] = 'tx=rollback';
      }
      return this;
    }
    /**
     * Override the type of the returned `data`.
     *
     * @typeParam NewResult - The new result type to override with
     */
  }, {
    key: "returns",
    value: function returns() {
      return this;
    }
  }]);
  return PostgrestTransformBuilder;
}(PostgrestBuilder);
export { PostgrestTransformBuilder as default };